import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  effect,
} from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import {
  PatientBehaviorDataModel,
  PatientTargetModel,
  PatientTargetStatus,
  PromptCodeModel,
  PromptScheduleModel,
  TargetType,
} from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { PatientTargetForChainModel } from '../../../shared/models/models';
@Component({
  selector: 'app-target-selector',
  templateUrl: './target-selector.component.html',
  standalone: false,
})
export class TargetSelectorComponent {
  @Input() target?: PatientTargetModel;
  private _promptCodes: PromptCodeModel[] = [];
  @Input()
  set promptCodes(value: PromptCodeModel[]) {
    this._promptCodes = value.filter((o) => !o.Inactive);
  }
  get promptCodes(): PromptCodeModel[] {
    return this._promptCodes;
  }
  @Input() allPromptCodes: PromptCodeModel[] = [];
  @Input() subTargetsDictionary: {
    [key: number]: PatientTargetForChainModel[];
  } = {};
  @Input() isBottomBox: boolean = false;
  @Input() enabled?: boolean = true;
  @Input() promptSchedules?: PromptScheduleModel[];
  @Input() isPreview?: boolean;
  promptSchedule: PromptScheduleModel | null = null;

  constructor(private patientSessionService: PatientSessionService) {}

  ngOnInit(): void {
    this.promptSchedule =
      this.promptSchedules?.find(
        (ps) => ps.ID === this.target?.PromptScheduleID
      ) ?? null;
  }

  isDurationTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Duration;
  }

  isFrequencyTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Frequency;
  }

  isDttTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.DiscreteTrialTeaching;
  }

  isConditionalDiscriminationTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.ConditionalDiscrimination;
  }

  isEchoicTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Echoic;
  }

  isFluencyRateTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.FluencyRate;
  }

  isGroupedFrequencyTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.GroupedFrequency;
  }

  isJumpToTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.JumpTo;
  }

  isQuantityTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Quantity;
  }

  isTaskAnalysisTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.TaskAnalysis;
  }

  isToiletingTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Toileting;
  }

  isWholePartialIntervalTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.WholePartialInterval;
  }

  isAnecdotalTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Anecdotal;
  }

  isDiscreteTrialTeachingTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.DiscreteTrialTeaching;
  }

  getTargetStatus(target: PatientTargetModel): PatientTargetStatus {
    return target.TargetStatus ?? PatientTargetStatus.Ready;
  }

  isIntervalTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.WholePartialInterval;
  }

  isCurrencyTarget(target: PatientTargetModel) {
    return target.TargetType === TargetType.Currency;
  }

  isMaintenaceTaken(target: PatientTargetModel) {
    if (target != null && target.ID != null) {
      var data = this.patientSessionService.getTargetData(target.ID ?? 0);
      var dT = target.DesiredTrials ?? 1;
      var dataTaken = data?.length ?? 0;
      if (
        target.MaintenanceDataTaken == true ||
        (dataTaken >= dT &&
          target?.TargetStatus === PatientTargetStatus.Maintenance)
      ) {
        return true;
      } else if (
        dataTaken <= dT &&
        target?.TargetStatus === PatientTargetStatus.Maintenance
      ) {
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
